export default __webpack_public_path__ + "static/media/596.877a8e48.gif";